import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import dayjs from 'dayjs'
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import { jsGetAge } from './libs/util'
//封装的主函数
import app from './callFunction/index'
import { Vip_type, export_data, img_url } from './libs/Fun'

import './assets/icon_custom/iconfont.css'
//导出组件
import JsonExcel from 'vue-json-excel'

Vue.component('DownloadExcel', JsonExcel)
Vue.use(ViewUI);
Vue.prototype.app = app.app
Vue.prototype.upLoad = app.upLoad
Vue.prototype.dayjs = dayjs
Vue.prototype.jsGetAge = jsGetAge
Vue.prototype.img_url = img_url
Vue.prototype.errorImg01 = require('@/assets/images/B_user/admin_logo.png') //处理文件的url 

Vue.config.productionTip = false

Vue.filter('dayjs', function (value, format) {
    if (!format) {
        format = 'YYYY-MM-DD'
    }
    return dayjs(value).format(format)
})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')